import React from "react";
import {
  Box,
  Center,
  Text,
  Heading,
  Link,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";

function Visit() {
  return (
    <Box bg="pink" py={10} textAlign="center" paddingBottom={"100px"}>
      <Heading
        as="h2"
        size="2xl"
        mb={4}
        color="white"
        fontFamily={["Sacramento"]}
        fontWeight={"400"}
        mt={"40px"}
      >
        We Would Love to See You!
      </Heading>
      <Text fontSize="lg" mb={6} color="white" fontFamily={"Open Sans"}>
        Visit us for an unforgettable beauty experience at:
      </Text>

      <Button
        as="a"
        href="#"
        rounded="full"
        size="lg"
        px={10}
        py={6}
        mb={"40px"}
        bg="pink.300"
        color="white"
        _hover={{ bg: "pink.500" }}
        onClick={() => {
          window.location.href =
            "https://www.google.com/maps/place/11400+Fourth+St+%23102,+Rancho+Cucamonga,+CA+91730/@34.0776817,-117.5582929,17z/data=!3m1!4b1!4m5!3m4!1s0x80c33583fed41d21:0x67ceb81e5efa4002!8m2!3d34.0776817!4d-117.555718?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D";
        }}
      >
        Get Directions
      </Button>
      <hr />

      <Center>
        <Text
          padding={"20px"}
          fontSize={"lg"}
          mt={"10px"}
          fontFamily={"Dosis"}
          fontWeight={"600"}
          wordBreak={"break-word"}
          width={"50%"}
          mb={"20px"}
        >
          WE ARE BY APPOINTMENT ONLY. <br /> <br /> Please note that all
          appointment bookings and cancellations must be made at least 24 hours
          in advance. If you are unable to attend, kindly notify us as soon as
          possible. Cancellations made less than 24 hours prior to your
          appointment will incur a $25 fee. The team at Annie's Nails and Lashes
          sincerely appreciate your cooperation.
        </Text>
      </Center>

      <hr />

      {/* Grid for Contact Information */}
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} mt={10}>
        <Box>
          <Heading size="md" color="pink.300">
            Visit Us
          </Heading>
          <Text color="gray.600">
            11400 4th St., Suite 102
            <br />
            Rancho Cucamonga, CA 91730
          </Text>
        </Box>
        <Box>
          <Heading size="md" color="pink.300">
            Call Us
          </Heading>
          <Text color="gray.600">Phone: (909) 697-0951</Text>
        </Box>
        <Box>
          <Heading size="md" color="pink.300">
            Follow Us
          </Heading>
          <Link
            href="https://www.instagram.com/annienguyenlashes/?igsh=MzRlODBiNWFlZA%3D%3D"
            color="gray.600"
          >
            Instagram: @annienguyenlashes
          </Link>
        </Box>
      </SimpleGrid>
    </Box>
  );
}

export default Visit;
